import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SzamlazzhuService } from 'src/app/services/szamlazzhu/szamlazzhu.service';
import { environment } from 'src/environments/environment';
import { LoadingScreenComponent } from '../../../shared/loading-screen/loading-screen.component';

@Component({
  selector: 'app-szamlazzhu-sso-response',
  templateUrl: './szamlazzhu-sso-response.component.html',
  styleUrls: ['./szamlazzhu-sso-response.component.scss'],
  imports: [LoadingScreenComponent],
})
export class SzamlazzhuSsoResponseComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private szamlazzhuService = inject(SzamlazzhuService);

  private token!: string;
  private error!: string;

  async ngOnInit() {
    // @todo @ivan - majd boviteni a production mode-al!
    const params = this.route.snapshot.queryParams;
    this.token = params.ssotoken;
    this.error = params.error;

    if (this.error) {
      return this.router.navigate(['sso/szamlazzhu/error'], {
        state: { error: this.error },
      });
    }

    if (this.token) {
      try {
        await this.szamlazzhuService.authenticate(this.token);
        await this.router.navigateByUrl(environment.afterLoginPath);
        return;
      } catch (e) {
        console.error('Error while logging in with szamlazzhu ssotoken', e);
        await this.router.navigateByUrl('sso/szamlazzhu/error');
      }
    } else {
      console.error('No token');
      await this.router.navigateByUrl('sso/szamlazzhu/error');
    }
  }
}
